import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { useIntl } from 'react-intl-next';
import Button from '@atlaskit/button/new';
import { FlagGroup } from '@atlaskit/flag';
import FeedbackIcon from '@atlaskit/icon/core/migration/feedback';
import { messages } from '../messages';
import FeedbackCollector from './FeedbackCollector';
import FeedbackFlag from './FeedbackFlag';
import { IntlProviderWithResolvedMessages } from './IntlProviderWithResolvedMessages';
/*
 * Standard feedback button with "Give Feedback" as the text and speaker icon on the left of the text
 * */
var FeedbackButton = function FeedbackButton(props) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    displayFlag = _useState4[0],
    setDisplayFlag = _useState4[1];
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var entrypointId = props.entrypointId,
    atlassianAccountId = props.atlassianAccountId,
    shouldGetEntitlementDetails = props.shouldGetEntitlementDetails,
    locale = props.locale;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      return setIsOpen(true);
    },
    iconBefore: function iconBefore(iconProps) {
      return /*#__PURE__*/React.createElement(FeedbackIcon, _extends({
        LEGACY_size: "small",
        color: "currentColor"
      }, iconProps));
    }
  }, formatMessage(messages.giveFeedback)), isOpen && /*#__PURE__*/React.createElement(FeedbackCollector, {
    locale: locale,
    onClose: function onClose() {
      return setIsOpen(false);
    },
    onSubmit: function onSubmit() {
      return setDisplayFlag(true);
    },
    atlassianAccountId: atlassianAccountId,
    entrypointId: entrypointId,
    shouldGetEntitlementDetails: shouldGetEntitlementDetails
  }), /*#__PURE__*/React.createElement(FlagGroup, {
    onDismissed: function onDismissed() {
      return setDisplayFlag(false);
    }
  }, displayFlag && /*#__PURE__*/React.createElement(FeedbackFlag, null)));
};
var FeedbackButtonWithIntl = function FeedbackButtonWithIntl(props) {
  var _useIntl2 = useIntl(),
    locale = _useIntl2.locale;
  return /*#__PURE__*/React.createElement(IntlProviderWithResolvedMessages, {
    locale: locale
  }, /*#__PURE__*/React.createElement(FeedbackButton, props));
};
export default FeedbackButtonWithIntl;